import { createContext, useState } from "react";
import { useDispatch } from "react-redux";
import { isEmpty } from "lodash";

import {
  getWalletsService,
  getWalletService,
  editWalletService,
  deleteWalletService,
} from "./../../../services/userServices";
import {
  setLoadingFalseAction,
  setLoadingTrueAction,
} from "./../../../redux/actions/loadingActions/loadingActions";
import {
  toastErrorMessage,
  toastSuccessMessage,
} from "../../../utils/toastMessage/toastMessage";

export const walletAdminContext = createContext({
  codes: [],
  setCodes: () => {},
  wallet: {},
  setWallet: () => {},
  amount: "",
  setAmount: () => {},
  chargeType: "",
  setChargeType: () => {},
  smsText: "",
  setSmsText: () => {},
  totalCount: null,
  setTotalCount: () => {},
  pageNumber: null,
  setPageNumber: () => {},
  limit: null,
  setLimit: () => {},
  handleCloseWalletModal: () => {},
  handleGetWallets: () => {},
  handleGetWallet: () => {},
  handleEditWallet: () => {},
  handleDeleteWallet: () => {},
});

const WalletAdminContext = ({ children, isUser = false }) => {
  // Redux Dispatch
  const dispatch = useDispatch();

  const [wallets, setWallets] = useState([]);
  const [wallet, setWallet] = useState({});
  const [amount, setAmount] = useState("");
  const [chargeType, setChargeType] = useState("normal");
  const [smsText, setSmsText] = useState("");
  const [totalCount, setTotalCount] = useState(0);
  const [pageNumber, setPageNumber] = useState(1);
  const [limit, setLimit] = useState(100);

  // Handle Close Wallet Modal
  const handleCloseWalletModal = () => {
    setWallet({});
    setAmount("");
    setChargeType("normal");
    setSmsText("");
  };

  // Handle Get Wallets Method
  const handleGetWallets = async (event) => {
    event?.preventDefault();
    const isSearch = !isEmpty(event);

    const objData = {
      offset: ((isSearch ? 1 : pageNumber) - 1) * limit,
      limit,
    };

    try {
      dispatch(setLoadingTrueAction());
      const { status, data } = await getWalletsService(objData);
      if (status === 200) {
        setWallets(data.results);
        setTotalCount(data.count);
      }
    } catch ({ response }) {
      if (response?.status) {
        toastErrorMessage();
      }
    } finally {
      dispatch(setLoadingFalseAction());
    }
  };

  // Handle Get Wallet Method
  const handleGetWallet = async (userId) => {
    try {
      dispatch(setLoadingTrueAction());
      const { status, data } = await getWalletService(userId);
      if (status === 200) {
        setWallet(data);
      }
    } catch ({ response }) {
      if (response?.status) {
        toastErrorMessage();
      }
    } finally {
      dispatch(setLoadingFalseAction());
    }
  };

  // Handle Edit Wallet Method
  const handleEditWallet = async (balance, change_type) => {
    const objData = {
      user: wallet?.user?.pk,
      current_balance: balance,
      charge_type: chargeType,
      sms_text: smsText,
      change_type,
    };

    try {
      dispatch(setLoadingTrueAction());
      const { status } = await editWalletService(objData);
      if (status === 200 || status === 201) {
        toastSuccessMessage(
          `کیف پول  ${wallet?.user?.first_name} ${wallet?.user?.last_name} با موفقیت ویرایش شد`
        );
        handleCloseWalletModal();
        if (!isUser) handleGetWallets();
      }
    } catch ({ response }) {
      if (response?.status) {
        toastErrorMessage();
      }
      if (!isUser) dispatch(setLoadingFalseAction());
    } finally {
      if (isUser) dispatch(setLoadingFalseAction());
    }
  };

  // Handle Delete Wallet Method
  const handleDeleteWallet = async (item) => {
    try {
      dispatch(setLoadingTrueAction());
      const { status } = await deleteWalletService(item.id);
      if (status >= 200 && status < 300) {
        toastSuccessMessage(
          `کیف پول  ${item?.user?.first_name} ${item?.user?.last_name} با موفقیت حذف شد`
        );
        handleGetWallets();
      }
    } catch ({ response }) {
      if (response?.status) {
        toastErrorMessage();
      }
      dispatch(setLoadingFalseAction());
    }
  };

  return (
    <walletAdminContext.Provider
      value={{
        wallets,
        setWallets,
        wallet,
        setWallet,
        amount,
        setAmount,
        chargeType,
        setChargeType,
        smsText,
        setSmsText,
        totalCount,
        setTotalCount,
        pageNumber,
        setPageNumber,
        limit,
        setLimit,
        handleCloseWalletModal,
        handleGetWallets,
        handleGetWallet,
        handleEditWallet,
        handleDeleteWallet,
      }}
    >
      {children}
    </walletAdminContext.Provider>
  );
};

export default WalletAdminContext;
